export const DEAL_ID_QUERY_PARAM = 'dealId';
export const GREENFIELD_ID_QUERY_PARAM = 'greenfieldId';
export const ACCOUNT_DETAILS_TAB_QUERY_PARAM = 'tab';
export const ROW_ID_QUERY_PARAM = 'rowId';
export const PARTNER_ID_QUERY_PARAM = 'partnerId';
export const RECORD_ID_QUERY_PARAM = 'recordId';
export const SOURCE_ID_QUERY_PARAM = 'sourceId';
export const SUBTAB_QUERY_PARAM = 'subTab';
export const PARTNER_CROSSBEAM_RECORD_ID_QUERY_PARAM =
  'partnerCrossbeamRecordId';
export const EMAIL_QUERY_PARAM = 'email';

export const DRAWER_QUERY_PARAMS = [
  DEAL_ID_QUERY_PARAM,
  GREENFIELD_ID_QUERY_PARAM,
  ACCOUNT_DETAILS_TAB_QUERY_PARAM,
  ROW_ID_QUERY_PARAM,
  PARTNER_ID_QUERY_PARAM,
  RECORD_ID_QUERY_PARAM,
  SOURCE_ID_QUERY_PARAM,
  SUBTAB_QUERY_PARAM,
  PARTNER_CROSSBEAM_RECORD_ID_QUERY_PARAM,
  EMAIL_QUERY_PARAM,
];

export const ACCOUNT_DETAILS_TAB = {
  ACCOUNT: 'account',
  PARTNERS: 'partners',
  CONTACTS: 'contacts',
  MESSAGES: 'messages',
  ACTIVITY: 'activity',
  NOTES: 'notes',
  OPPORTUNITIES: 'opportunities',
} as const;
export type AccountDetailsTab =
  (typeof ACCOUNT_DETAILS_TAB)[keyof typeof ACCOUNT_DETAILS_TAB];
